// DEMAND
export const GET_DEMAND: { [x: string]: any } = {
  LOADING: "DEMAND_GET_LOADING",
  SUCCESS: "DEMAND_GET_SUCCESS",
  ERROR: "DEMAND_GET_ERROR",
};

export const GET_SINGLE_DEMAND: { [x: string]: any } = {
  LOADING: "SINGLE_DEMAND_GET_LOADING",
  SUCCESS: "SINGLE_DEMAND_GET_SUCCESS",
  ERROR: "SINGLE_DEMAND_GET_ERROR",
};

export const CREATE_DEMAND: { [x: string]: any } = {
  LOADING: "DEMAND_CREATE_LOADING",
  SUCCESS: "DEMAND_CREATE_SUCCESS",
  ERROR: "DEMAND_CREATE_ERROR",
};

export const UPDATE_DEMAND: { [x: string]: any } = {
  LOADING: "DEMAND_UPDATE_LOADING",
  SUCCESS: "DEMAND_UPDATE_SUCCESS",
  ERROR: "DEMAND_UPDATE_ERROR",
};

export const DELETE_DEMAND: { [x: string]: any } = {
  LOADING: "DEMAND_DELETE_LOADING",
  SUCCESS: "DEMAND_DELETE_SUCCESS",
  ERROR: "DEMAND_DELETE_ERROR",
};
